import { Action, createAction, props } from '@ngrx/store';
// import { type } from 'os';

/**
 * Tipos de Acción para el Store de Permisos
 */
export enum OperacionActionTypes {
    AsignaPermisos = '[Permisos] Asigna Permisos',
    AsignaBreadcrumb = '[Permisos] Adigna Breadcrumb',
    
    EliminaOperacion = '[Operacion] Elimina Permisos',
    AsignarOperacion = '[Operacion] Asigna operacion en sesion abierta',
    AsignarOperacionEstatus = '[Operacion] Asigna operacion en sesion abierta',
}

export class AsignarOperacion implements Action{
    readonly type = OperacionActionTypes.AsignarOperacion;
    constructor( public payload:any ){}
}

export class EliminaOperacion implements Action{
    readonly type = OperacionActionTypes.EliminaOperacion;
    constructor( ){}
}

export type All = AsignarOperacion | EliminaOperacion;